import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormTextField } from '@grupo-constant/next-dtype/form';
import {
    ADDRESSBYGOOGLE_COLUMN_URI,
    DATEPICKER_COLUMN_URI,
    DTypeCol, DTypeViewableCol, INTEGER_COLUMN_URI,
    LANGUAGETEXT_COLUMN_URI,
    REAL_COLUMN_URI,
    SelectOption,
    TEXT_COLUMN_URI,
    TIMEPICKER_COLUMN_URI
} from '@grupo-constant/next-dtype/types';
import { Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { DTypeService } from '../../dtype.service';
import { Utils } from '../../../utils/utils';

@Component({
    selector: 'text-mask-field-component',
    templateUrl: './text-mask-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeTextMaskFieldComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {

    @Input() field: DTypeFormTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    // TEXT MASK
    columns: DTypeCol[];
    validTypes = [
        TEXT_COLUMN_URI,
        LANGUAGETEXT_COLUMN_URI,
        INTEGER_COLUMN_URI,
        REAL_COLUMN_URI,
        DATEPICKER_COLUMN_URI,
        TIMEPICKER_COLUMN_URI,
        ADDRESSBYGOOGLE_COLUMN_URI
    ];

    private _unsubscribeAll = new Subject<void>();

    constructor(private dtypeService: DTypeService) { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }

        if (!this.field.option?.length) {
            this.dtypeService.columns$
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(columns => this.columns = columns.filter(c => this.columnIsValid(c)));
        }
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    add(option: DTypeCol | SelectOption) {
        const str = this.field.control.value ?? '';
        if (Utils.interfaceOf<DTypeCol>(option, 'name')) {
            this.field.control.setValue(str + '{{' + option.name + '}}');
        } else if (Utils.interfaceOf<SelectOption>(option, 'code')) {
            this.field.control.setValue(str + '{{' + option.code + '}}');
        }
    }

    private columnIsValid(column: DTypeCol) {
        return this.validTypes.includes(column.type);
    }

}
